import { OKTA_EMAIL_FACTOR } from 'store';
import { STEP_ABOUT_YOU, STEP_LATITUDE_ID, STEP_PROCESSING } from '_config';
import { isFeatureOn } from 'featureToggles';

export function nextStepAfterVerification({
  isLatitudeIdPasswordSet,
  factor,
  oktaProfileHealthy,
  applicationSubmitted,
}) {
  const smsEmailOptIn = isFeatureOn('smsEmailVerificationOptions');
  const emailVerificationEnabled = isFeatureOn('emailVerification');

  // Resume cases are handled in useResume hook
  const isEmailFactor = factor === OKTA_EMAIL_FACTOR;

  // Post-submission: healthy Okta profile verified via email
  if (
    applicationSubmitted &&
    ((!emailVerificationEnabled && isEmailFactor && oktaProfileHealthy) || (emailVerificationEnabled && isEmailFactor))
  ) {
    return isLatitudeIdPasswordSet ? STEP_PROCESSING : STEP_LATITUDE_ID;
  }

  if (!applicationSubmitted && isEmailFactor && smsEmailOptIn) {
    // New applicant opting into email verification
    return STEP_ABOUT_YOU;
  }

  if (applicationSubmitted && isEmailFactor) {
    // Post-submission email verification
    return isLatitudeIdPasswordSet ? STEP_PROCESSING : STEP_LATITUDE_ID;
  }

  // Default AU flow: determine next step based on password status and email verification feature
  return !isLatitudeIdPasswordSet && !emailVerificationEnabled ? STEP_LATITUDE_ID : STEP_ABOUT_YOU;
}
